import "../App.css";
// images
import AidProgram3 from "../assets/events/aid-program-3.jpg";
import AidProgram4 from "../assets/events/aid-program-4.jpg";
import OpenHouse1 from "../assets/events/open-house-talk-1.jpg";
import OpenHouse7 from "../assets/events/open-house-booth-7.jpg";
import OpenHouse8 from "../assets/events/open-house-booth-8.jpg";
import OpenHouse9 from "../assets/events/open-house-booth-9.jpg";
import OpenHouse0 from "../assets/events/open-house-group-10.JPG";
import Snk2 from "../assets/events/snk-2.jpg";
import Snk5 from "../assets/events/snk-5.png";
import Snk7 from "../assets/events/snk-7.png";

export default function Thesis() {
	const gallery = {
		aidProgram: [AidProgram3, AidProgram4],
		openHouse: [OpenHouse7, OpenHouse8, OpenHouse9, OpenHouse0, OpenHouse1],
		snk: [Snk2, Snk5, Snk7],
	};

	return (<div className="bg-black">
		<div className="gallery">
			{Object.entries(gallery).map(([category, images]) =>
				images.map((img, i) => (
					<div className="gallery-img">
						<img
							key={`${category}-${i}`}
							src={img}
							alt={`${category} ${i + 1}`}
							data-text={category === "aidProgram" ? "Aid Program"
								: category === "openHouse" ? "Open House"
									: category === "snk" ? "SNK"
										: category}
						/>
						<div className="lightbox" data-text={category === "aidProgram" ? "CIIT Aid Program 2025"
							: category === "openHouse" ? "CIIT Open House 2025"
								: category === "snk" ? "\"Sampaguita, Napaano Ka?\": Bullying Prevention Campaign"
									: "image"}
							onClick={() => {
								window.open(
									category === "aidProgram" ? "https://www.facebook.com/share/p/171dTgDrrd/"
										: category === "openHouse" ? "https://www.facebook.com/share/p/1Ccok6gYky/"
											: category === "snk" ? "https://www.facebook.com/share/p/1CFWH3bPLy/"
												: "#"
									, "_blank")
							}}
						></div>
					</div>
				))
			)}
		</div>
	</div >);
}